import * as React from "react";
import { useLocation, useParams } from "react-router-dom";
import { AlertMessage, AlertType, ButtonType, CustomButton, SpinnerWrapper } from "soprasteria-ui-library";
import { useAuth } from "../../../App";
import { OrganisationApi } from "../../../api/OrganisationApi";
import { setMessage } from "../../../helpers/MessageHelper";
import { IOrganisation, IOrganisationTab } from "../../../models/IOrganisation";
import { EditOrganisationModal } from "./EditOrganisationModal";
import { OrganisationInformation } from "./OrganisationInformation";
import { OrganisationTabs } from "./Tabs/OrganisationTabs";

export const Organisation: React.FC<{}> = () => {
    const auth = useAuth();
    const api = new OrganisationApi(auth);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const [successMessage, setSuccessMessage] = React.useState<string>("");
    const [organisation, setOrganisation] = React.useState<IOrganisation>();
    const location = useLocation();
    const { id } = useParams<{ id: string }>();
    const [selectedTab, setSelectedTab] = React.useState<IOrganisationTab>();
    const [renderModal, setRenderModal] = React.useState<boolean>(false);

    React.useEffect(() => {
        loadOrganisation(parseInt(id));
    }, [location]);

    const loadOrganisation = (organisationId: number) => {
        setIsLoading(true);
        api.getOrganisationById(organisationId, (result) => {
            setOrganisation(result);
        }, (error) => { setErrorMessage(error) }, () => { setIsLoading(false); });
    }

    const closeModal = () => {
        setRenderModal(false);
    }

    const onSubmit = (organisationId: number) => {
        document.getElementById("close-edit-organisation-modal")?.click();
        loadOrganisation(organisationId);
        setSuccessMessage(setMessage("Vårdgivaren har sparats", successMessage));
    }

    const onTabSubmit = (message: string, tab: IOrganisationTab) => {
        setSuccessMessage(setMessage(message, successMessage));
        if (organisation) {
            const organisationId = organisation.organisationId;
            setOrganisation(undefined);
            loadOrganisation(organisationId);
            setSelectedTab(tab);
        }
    }

    return (
        <SpinnerWrapper isLoading={isLoading}>
            <section className="card">
                <div className="card-header">
                    <div className="row">
                        <div className="col">
                            <h1>Vårdgivare (Organisation)</h1>
                        </div>
                        <div className="col">
                            <div className="text-right">
                                <CustomButton buttonText="Redigera vårdgivare" buttonType={ButtonType.edit} onClick={() => setRenderModal(true)} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="col-12">
                        <AlertMessage alertType={AlertType.success} duration={5000} >{successMessage}</AlertMessage>
                        <AlertMessage alertType={AlertType.danger} duration={5000}>{errorMessage}</AlertMessage>
                    </div>
                    {
                        organisation ?
                            <div className="relative">
                                <div className="row">
                                    <OrganisationInformation organisation={organisation} />
                                </div>
                            </div>
                            : null
                    }
                    {
                        organisation ?
                            <>
                                <div className="row extra-top-margin">
                                    <div className="col-12">
                                        <OrganisationTabs organisationId={organisation.organisationId} selectedTab={selectedTab} onTabSubmit={onTabSubmit} />
                                    </div>
                                </div>

                            </>
                            : null
                    }
                </div>
                {
                    organisation && renderModal ?
                        <EditOrganisationModal organisation={organisation!} closeModal={closeModal} onSubmit={onSubmit} />
                        : null
                }
            </section>
        </SpinnerWrapper>

    );
}